import * as React from "react";
import GoogleMapReact from "google-map-react";
import { IMapCenter } from "../../../../share/types/common";
import * as utils from "google-map-react/utils";
import { IAlert } from "src/share/types/alert";
import { mapStyle } from "src/share/utils/mapStyle";
import markerImage from "../../../../images/marker.svg"

declare var google;
export interface IMapProps {
  center?: IMapCenter;
  isGrid?: boolean;
  radius?: number;
  marker?: boolean;
  draggable?: boolean;
  alerts?: IAlert[];
  zoomControl?: boolean;
  initialZoom?: number;
  noLocationData?: boolean;
}
export interface IMapState {
  center?: IMapCenter;
  zoom: number;
  radius?: number;
}
const MILESTOMETERS = 1609.34;
const LIMITMILES = 1000 * MILESTOMETERS;
export const Radius = ({ height, width }) => {
  const style = { height, width };
  return <div className={`radius-container radius`} style={style} />;
};
export const Marker = (props) => {
  return (
    <div className="marker-container">
      <img className="marker" src={markerImage} />
    </div>
  );
};
export class Map extends React.Component<IMapProps, IMapState> {
  constructor(props: IMapProps) {
    super(props);
    this.state = {
      center: props.center,
      zoom: props.initialZoom || 8,
      radius: (props.radius || 0) * MILESTOMETERS
    };
  }
  public static getDerivedStateFromProps(props: IMapProps, state: IMapState) {
    return {
      ...state,
      center: props.center,
      radius: props.radius ? props.radius * MILESTOMETERS : null
    };
  }
  public onInit = mapAPI => {
    const { map } = mapAPI;
    this.setListeners(map);
    this.onChange(map);
    if (this.props.isGrid) {
      this.setState({ zoom: map.getZoom() }, () => this.fitToRadius(map));
    }
  };
  public onMapChange = (map) => {
    this.fitToRadius(map);
    this.onChange(map);
  };
  public setListeners(map) {
    google.maps.event.addListener(map, "idle", () => this.onMapChange(map));
    google.maps.event.addListener(map, "bounds_changed", () => this.onChange(map));
  }
  public onChange(map) {
    this.setState({ zoom: this.state.center ? map.getZoom() : 1 });
  }
  public fitToRadius(map) {
    if (this.state.center && this.state.radius) {
      const circle = new google.maps.Circle({
        center: this.state.center,
        radius: this.state.radius * (this.props.isGrid ? 0.2 : 1)
      });
      map.fitBounds(circle.getBounds());
    }
  }
  public getRadiusSize() {
    if (this.state.center && this.state.radius) {
      const { lat, lng } = this.state.center;
      return utils.meters2ScreenPixels(
        this.state.radius * 2,
        { lat, lng },
        this.state.zoom
      );
    }
    return { w: 0, h: 0 };
  }
  public render() {
    const { w, h } = this.getRadiusSize();
    const alerts: any = this.props.alerts && this.props.alerts.length > 0 ? this.props.alerts : []
    return (
      <div
        className="map"
        style={{ height: "calc(100% - 50px)", width: "100%" }}
      >
        {this.state.radius && this.state.radius <= LIMITMILES && <Radius width={w} height={h} />}
        {
          this.props.noLocationData &&
          <div className="noLocationInfo">
            <h4>Location data not available</h4>
          </div>
        }
        <GoogleMapReact
          options={{
            zoomControl: this.props.zoomControl === true,
            draggable: this.props.draggable ? true : false,
            fullscreenControl: false,
            styles: mapStyle
          }}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={this.onInit}
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY || "" }}
          center={
            this.state.center ? this.state.center : { lat: 18.89, lng: -45.35 }
          }
          zoom={this.state.zoom}
        >
          {this.props.marker && <Marker {...this.state.center} />}
          {alerts.map((alert) => <Marker key={alert.alertId} {...alert.center} />)}
          {this.props.children}
        </GoogleMapReact>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/Map.tsx